/* global __RELEASE__, __GITSHA__ */
/* The above variables are injected by Webpack during build */

function guessEnvironment() {
  var assetModifier;
  const serverEnv = serverEnvironment();

  if (serverEnv) {
    return serverEnv;
  }

  // Otherwise, fall back to implied environment name
  const domain = document.location.href.split('/')[2].replace(/\./g, '-');
  const build = buildType();

  if (build === 'unknown') {
    assetModifier = 'unknown-assets';
  } else if (build === 'production') {
    assetModifier = 'prod';
  } else {
    assetModifier = 'dev-assets';
  }
  return [domain, assetModifier].join('#');
}

function buildType() {
  const buildElement = document.querySelector('meta[name=build]');

  if (!buildElement) {
    return 'unknown';
  } else {
    return buildElement.content;
  }
}

function serverEnvironment() {
  const explicitEnvironment = document.querySelector('meta[name=environment]');

  // If the template tells us the environment name
  if (explicitEnvironment && explicitEnvironment.content) {
    return explicitEnvironment.content;
  }
}

function serverDeployTime() {
  const deployElement = document.querySelector('meta[name=deployed_at]');

  // If the template tells us the environment name
  if (deployElement) {
    return deployElement.content || 0;
  } else {
    return 0;
  }
}

function serverSha() {
  const shaElement = document.querySelector('meta[name=sha]');

  // If the template tells us the environment name
  if (shaElement) {
    return shaElement.content || 'Unknown';
  } else {
    return 'Unknown';
  }
}

function serverBranch() {
  const branchElement = document.querySelector('meta[name=branch]');

  // If the template tells us the environment name
  if (branchElement) {
    return branchElement.content || 'Unknown';
  } else {
    return 'Unknown';
  }
}

module.exports = {
  version: (typeof __RELEASE__ !== 'undefined') ? __RELEASE__ : 'UNDEFINED',
  jsSha: (typeof __GITSHA__ !== 'undefined') ? __GITSHA__ : 'UNDEFINED',
  build: buildType(),
  environment: guessEnvironment(),
  serverDeployTime: serverDeployTime(),
  serverSha: serverSha(),
  serverBranch: serverBranch()
};



//////////////////
// WEBPACK FOOTER
// ./src/js/config/runtime.js
// module id = 33
// module chunks = 0